import { render, staticRenderFns } from "./wheel-battle.vue?vue&type=template&id=77345dc4&scoped=true&"
import script from "./wheel-battle.vue?vue&type=script&lang=js&"
export * from "./wheel-battle.vue?vue&type=script&lang=js&"
import style0 from "./wheel-battle.vue?vue&type=style&index=0&id=77345dc4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77345dc4",
  null
  
)

export default component.exports